<template>
  <div class="storefront fill-height" style="width: 100%;">
    <WebshopStore v-if="filterVisible" />
    <CampaignsPromotion v-else />
  </div>
</template>

<script>
import CampaignsPromotion from "./views/CampaignsPromotion";
import WebshopStore from "./views/WebshopStore";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import { mapWaitingActions } from "vue-wait";

export default {
  created() {
    console.log("created storefront: ");
  },
  mixins: [webshopMixins],
  computed: {
    breadcrumbs() {
      return getBreadcrumbs(this.$route.name);
    },
  },
  methods: {
        ...mapWaitingActions("webshop", {
      getPopularProducts: "loading webshop getPopularProducts",
    }),
    removeUrlQuerry() {
      // !!TO-DO: thik about middle state for filter on mobile or add a remove all filters
      if (
        Object.keys(this.$route.query).length > 0 &&
        this.$route.query.constructor === Object
      ) {
        this.$router.replace({ query: {} });
      }
      this.drawer = false;
    },
  },
  async created() {
    if (this.$user.onlineSluttKundeId) await this.previouslyBoughtProducts;
  },
  components: {
    WebshopStore,
    CampaignsPromotion,
  },
   watch: {
     '$route.params':{
       handler(val){
         if(val?.chainId && this.$route?.name == 'webshopChain'){
           this.getPopularProducts({
             chainId: val?.chainId,
             siteId: 0
           })
         }
       }, immediate: true
     }
  },
};
</script>
